"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Triggers = void 0;
var Triggers;
(function (Triggers) {
    Triggers["TurnStartTrigger"] = "TurnStartTrigger";
    Triggers["TurnEndTrigger"] = "TurnEndTrigger";
    Triggers["CreaturePlayedTrigger"] = "CreaturePlayedTrigger";
    Triggers["CreatureDestroyedTrigger"] = "CreatureDestroyedTrigger";
    Triggers["CreatureDamagedTrigger"] = "CreatureDamagedTrigger";
    Triggers["CreatureAttackTrigger"] = "CreatureAttackTrigger";
    Triggers["SpellPlayedTrigger"] = "SpellPlayedTrigger";
    Triggers["MonkeyDamagedTrigger"] = "MonkeyDamagedTrigger";
    Triggers["VictoryTrigger"] = "VictoryTrigger";
})(Triggers = exports.Triggers || (exports.Triggers = {}));
